/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Delete_All_DescInputs */

const en_ui_data_delete_all_desc = /** @type {(inputs: Ui_Data_Delete_All_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permanently remove all sessions, records, and your profile`)
};

const de_ui_data_delete_all_desc = /** @type {(inputs: Ui_Data_Delete_All_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Einheiten, Aufzeichnungen und dein Profil dauerhaft entfernen`)
};

/**
* | output |
* | --- |
* | "Permanently remove all sessions, records, and your profile" |
*
* @param {Ui_Data_Delete_All_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_delete_all_desc = /** @type {((inputs?: Ui_Data_Delete_All_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Delete_All_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_delete_all_desc(inputs)
	return de_ui_data_delete_all_desc(inputs)
});